export class DetalleCesionRequest {
   cesionarioId: string;
   fechaUltimoVencimiento: Date;
   correoDeudor: string;
   montoCesion: number;
   declaracionJurada: string;
   otrasCondiciones: string;
}
